export const messages = {
  en: {
    allocationStorehouseEnter: {
      page: {
        title: 'Allocation Inbound',
        subtitle: 'Confirm actual inbound quantities for allocation',
        empty: 'No allocation items found'
      },
      title: 'Allocation Warehouse Entry',
      applyId: 'Apply ID: ',
      resourceType: 'Resource Type',
      resourceName: 'Resource Name',
      specification: 'Specification',
      resourceCode: 'Resource Code',
      fixedResource: 'Fixed Resource',
      transferredWarehouse: 'Transferred Warehouse',
      returnPerson: 'Return Person',
      originalWarehouse: 'Original Warehouse',
      targetWarehouse: 'Target Warehouse',
      originalStock: 'Original Stock',
      transferQuantity: 'Transfer Quantity',
      actualQuantity: 'Actual Quantity',
      quantityPlaceholder: 'Required, please enter the transfer quantity',
      submit: 'Submit',
      fetchError: 'Failed to fetch allocation data',
      selectItemsWarning: 'Please select items to transfer',
      quantityWarning: 'Please enter valid quantity for all selected items',
      submitSuccess: 'Operation successful',
      submitError: 'Operation failed'
    }
  },
  zh: {
    allocationStorehouseEnter: {
      page: {
        title: '调拨入库',
        subtitle: '确认调拨物品实际入库数量',
        empty: '暂无调拨物品'
      },
      title: '调拨入库',
      applyId: '单号：',
      resourceType: '物品类型',
      resourceName: '物品名称',
      specification: '物品规格',
      resourceCode: '物品编码',
      fixedResource: '固定物品',
      transferredWarehouse: '被调仓库',
      returnPerson: '退还人',
      originalWarehouse: '原仓库',
      targetWarehouse: '目标仓库',
      originalStock: '原库存',
      transferQuantity: '调拨数量',
      actualQuantity: '实际数量',
      quantityPlaceholder: '必填，请填写调拨数量',
      submit: '提交',
      fetchError: '获取调拨数据失败',
      selectItemsWarning: '请选择调拨物品',
      quantityWarning: '请为所有选中物品填写有效数量',
      submitSuccess: '操作成功',
      submitError: '操作失败'
    }
  }
}